module.exports = __webpack_public_path__ + "img/globe-slated-02.9c3bed3b.svg";